<script>
import ValoresCultura from "@/components/intranet/cultura/ValoresCultura.vue";
import ModalValor from "@/components/intranet/cultura/ModalValor.vue";
import { mapState ,mapActions } from "vuex";
export default {
  name: "Cultura",
  data() {
    return {
      nombreModal: "",
      descripcionModal: "",
      imagenModal: "",

      //FF
      valor: {}
    };
  },
  computed:{
      ...mapState("CulturaModule", ["culturas"]), 
  },
  created() {
    this.getCulturaEmpresa();
  },
  components: {
    ValoresCultura,
    ModalValor
},
  methods: {
    ...mapActions("CulturaModule", ["getCultura"]),
    abrirModal(nombre, descripcion, imagen) {
      this.nombreModal = nombre;
      this.descripcionModal = descripcion;
      this.imagenModal = imagen;
    },
    async getCulturaEmpresa() {
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk, 
      }
      await this.getCultura(data_);
    },
    valorCapturado(valor) {
      this.valor = valor;
    }
  },
};
</script>

<template>

<section id="cultura">

  <div class="row">
    <div class="col-12 mb-0">
      <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
<!--         <IconReconoce class="me-2 icon-svg-45"/> -->
        Cultura
      </h1>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link 
              to="/home"
              class="color-main"
            >
              <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
              Inicio
            </router-link>
          </li>
          <li class="breadcrumb-item text-capitalize active">
            Cultura
          </li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="row d-flex mt-2">
      <div class="col-12 col-lg-8 mb-3 mb-lg-0 d-flex align-items-center">
        <p class="text-secondary h5-custom mb-0">
          ¡Conoce que nos mueve y los valores que llevamos en la compañía!
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div> 

    <div class="row">
      <div class="col-12">
        <div class="card border-0 card-shadow overflow-600">
          <div class="card-body p-5">
            <div 
              v-for="descripcion in culturas.descripcion" 
              :key="descripcion.id_descripcion"
            >
              <h2
                class="font-700 color-main"
                v-if="descripcion.titulo"
              >
                {{ descripcion.titulo }}
              </h2>
              <p
                class="text-secondary"
                v-if="descripcion.texto"
                v-html="descripcion.texto"></p>

                <div class="row d-flex justify-content-center">
                  <div class="col-12 col-lg-5">
                    <img
                      v-if="descripcion.url_documento && /.png|.jpg|.jpeg/.test(descripcion.url_documento)"
                      :src="descripcion.url_documento"
                      class="rounded-4 img-fluid"
                      alt="Imagen representativa de Misión y Visión"
                    />
                  </div>
                </div>
            </div>

            <ValoresCultura @valorCapturado="valorCapturado"/>
          </div>
        </div>
      </div>
    </div>

    <ModalValor :data="valor"/>
  </section>
</template>
